import React from 'react';
import Proptypes from 'prop-types';
import classnames from 'classnames';
import MaterialTableHead from '@material-ui/core/TableHead';
import Icon from '../../Icon/Icon';
import { TableRow, TableCell } from '@material-ui/core';
import styles from './TableHead.scss';

const TableHead = ({ columns, onSortTable, sortField, sortOrder }) => {
    const createSortableCell = column =>
        <span
            onClick={() => onSortTable(column.name)}>
            { column.label }
            {
                sortField === column.name ?
                    <Icon
                        name={sortOrder === 'asc' ? "ion-md-arrow-dropup" : "ion-md-arrow-dropdown"}
                        className={styles.arrowIcon}
                    /> :
                    <Icon
                        name="ion-md-arrow-dropdown"
                    />
            }
        </span>;

    return (
        <MaterialTableHead>
            <TableRow className={styles.tableHead}>
                {
                    columns.map((column) =>
                        <TableCell
                            className={
                                classnames(styles.tableHeadCell,
                                    { [styles[`size-${column.size}`]]: column.size })
                            }
                            key={column.name}
                            align='center'>
                            {
                                column.isSortable ?
                                    createSortableCell(column) :
                                    column.label
                            }
                        </TableCell>
                    )
                }
                <TableCell
                    className={classnames(styles.tableHeadCell, styles.sizeSmall)}
                />
            </TableRow>
        </MaterialTableHead>
    );
};

TableHead.propTypes = {
    columns: Proptypes.arrayOf(Proptypes.shape({
        label: Proptypes.string.isRequired,
        size: Proptypes.oneOf(['large', 'small']),
        isSortable: Proptypes.bool,
        name: Proptypes.string.isRequired
    })).isRequired,
    onSortTable: Proptypes.func.isRequired,
    sortField: Proptypes.string.isRequired,
    sortOrder: Proptypes.string.isRequired
};

export default TableHead;

